<template>
  <el-dialog
    top="15vh"
    :visible.sync="showModal"
    :before-close="handleClose"
    :append-to-body="true"
    :width="modalWidth"
    :show-close="false"
    custom-class="custom-scrollable"
    test-id="view-director"
  >
    <div class="flex justify-between -mt-8 mb-6 md:mb-8 bg-white w-full px-2">
      <span
        class="text-black-10 text-lg md:text-lg font-bold"
        style="word-break: normal"
      >
        Directors and Ultimate Beneficiary Owner Information</span
      >
      <span class="cursor-pointer" @click="handleClose" test-id="closeIcon">
        <close-icon size="h-6 w-6" />
      </span>
    </div>

    <el-form
      @submit.native.prevent="removeDirector"
      label-position="top"
      :model="kycDetailsForm"
      ref="kycDetailsForm"
      test-id="form"
    >
      <div class="flex flex-col px-2">
        <p
          v-if="kycDetailsForm.type !== 'entity'"
          class="flex items-center mb-4"
        >
          <el-checkbox v-model="directorIsUbo">
            <span class="mt-2"
              >Select this Director as the Ultimate Beneficiary Owner
              (UBO)</span
            >
          </el-checkbox>
        </p>
        <!-- title -->
        <el-form-item v-if="kycDetailsForm.title" class="w-full" prop="title">
          <p>Title <span class="text-error-10">*</span></p>
          <el-select
            class="w-full"
            v-model="kycDetailsForm.title"
            placeholder="Select"
          >
            <el-option
              v-for="(title, index) in titles"
              :key="index"
              :label="title.label"
              :value="title.value"
            >
              {{ title.label }}
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="w-full" test-id="formItem">
          <p>{{ type === 'entity' ? 'Entity ' : ' ' }} Name *</p>
          <el-input
            class="w-full"
            v-model="kycDetailsForm.name"
            readonly
          ></el-input>
        </el-form-item>
        <div v-if="type === 'entity'" class="flex flex-col md:flex-row gap-2">
          <el-form-item class="w-full md:w-1/2" prop="idNumber">
            <p>Incorporation Number <span class="text-error-10">*</span></p>
            <el-input v-model.trim="kycDetailsForm.idNumber"></el-input>
          </el-form-item>

          <el-form-item class="w-full md:w-1/2" prop="shareholding">
            <p>Shareholding (%) <span class="text-error-10">*</span></p>
            <el-input v-model="kycDetailsForm.shareholding" type="number" />
          </el-form-item>
        </div>

        <el-form-item v-if="kycDetailsForm.phoneNumber" test-id="formItem">
          <p>Mobile Number *</p>
          <el-input
            class="w-full"
            v-model="kycDetailsForm.phoneNumber"
            readonly
          ></el-input>
        </el-form-item>

        <div
          class="flex flex-col md:flex-row gap-2"
          v-if="kycDetailsForm.gender"
        >
          <el-form-item class="w-full md:w-1/2" test-id="formItem">
            <p>Gender *</p>
            <el-input
              class="w-full"
              v-model="kycDetailsForm.gender"
              readonly
            ></el-input>
          </el-form-item>

          <el-form-item class="w-full md:w-1/2" test-id="formItem">
            <p>Date of Birth *</p>
            <el-date-picker
              v-model="kycDetailsForm.dateOfBirth"
              type="date"
              placeholder="YYYY-MM-DD"
              class="w-full"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              readonly
            />
          </el-form-item>
        </div>

        <div
          v-if="kycDetailsForm.idType"
          class="flex flex-col md:flex-row gap-2"
        >
          <el-form-item class="w-full md:w-1/2" test-id="formItem">
            <p>Valid ID Type *</p>
            <el-input
              class="w-full"
              v-model="kycDetailsForm.idType"
              readonly
            ></el-input>
          </el-form-item>

          <el-form-item class="w-full md:w-1/2" test-id="formItem">
            <p>ID Number *</p>
            <el-input v-model="kycDetailsForm.idNumber" readonly></el-input>
          </el-form-item>
        </div>

        <el-form-item v-if="kycDetailsForm.country" test-id="formItem">
          <p>Country of Residence *</p>
          <el-input
            class="w-full"
            v-model="kycDetailsForm.country"
            readonly
          ></el-input>
        </el-form-item>

        <el-form-item
          v-if="kycDetailsForm.bvn"
          class="w-full"
          test-id="formItem"
        >
          <p>{{ bvnTitle }} *</p>
          <el-input
            class="w-full"
            v-model="kycDetailsForm.bvn"
            readonly
          ></el-input>
        </el-form-item>
        <div v-if="type !== 'entity'" class="flex flex-col md:flex-row gap-2">
          <el-form-item class="w-full md:w-1/2" prop="citizenship">
            <p>Citizenship <span class="text-error-10">*</span></p>
            <el-select
              class="w-full"
              v-model="kycDetailsForm.citizenship"
              placeholder="Select"
            >
              <el-option
                v-for="(item, index) in citizenshipOptions"
                :key="index"
                :label="item.label"
                :value="item.value"
              >
                {{ item.label }}
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item class="w-full md:w-1/2" prop="shareholding">
            <p>
              Shareholding %
              {{ isUltimateBeneficiaryOwner ? '' : '(Optional)'
              }}<span v-if="isUltimateBeneficiaryOwner" class="text-error-10"
                >*</span
              >
            </p>
            <el-input
              class="w-full flex items-center"
              type="number"
              v-model="kycDetailsForm.shareholding"
              readonly
            >
            </el-input>
          </el-form-item>
        </div>

        <el-form-item
          v-if="kycDetailsForm.address"
          class="w-full"
          test-id="formItem"
        >
          <p>Address *</p>
          <el-input
            class="w-full"
            v-model="kycDetailsForm.address"
            readonly
          ></el-input>
        </el-form-item>

        <div class="flex flex-col md:flex-row gap-2">
          <el-form-item
            v-if="kycDetailsForm.state"
            class="w-full"
            test-id="formItem"
          >
            <p>State *</p>
            <el-input
              class="w-full"
              v-model="kycDetailsForm.state"
              readonly
            ></el-input>
          </el-form-item>

          <el-form-item
            v-if="kycDetailsForm.postalCode"
            class="w-full"
            test-id="formItem"
          >
            <p>Postal Code *</p>
            <el-input
              class="w-full"
              v-model="kycDetailsForm.postalCode"
              readonly
            ></el-input>
          </el-form-item>
        </div>

        <div class="my-3" v-if="kycDetailsForm.idCard">
          <h4 class="text-base font-bold text-black-10">Documents to Attach</h4>
          <p class="text-gray-muted text-xs md:text-sm mt-1">
            We only allow JPG, PNG, GIF and PDF
          </p>
        </div>

        <el-form-item v-if="kycDetailsForm.idCard" test-id="formItem">
          <p>
            {{
              type !== 'entity' ? 'Valid ID Card' : 'Incorporation Certificate '
            }}
            *
          </p>
          <el-input
            accept=".jpg,.jpeg,.png,.pdf,.gif"
            v-model="kycDetailsForm.idCard"
            readonly
          >
          </el-input>
        </el-form-item>

        <el-form-item v-if="kycDetailsForm.proofOfAddress" test-id="formItem">
          <p>
            {{
              type === 'entity'
                ? 'Proof of Address ( Date within the last three months )'
                : 'Shareholding Details '
            }}
            *
          </p>
          <el-input
            accept=".jpg,.jpeg,.png,.pdf,.gif"
            v-model="kycDetailsForm.proofOfAddress"
            readonly
          >
          </el-input>
        </el-form-item>

        <el-form-item v-if="type !== 'entity'" test-id="formItem">
          <p class="text-sm md:text-base text-black font-medium my-2">
            Politically Exposed Person (PEP) *
          </p>
          <el-radio-group v-model="kycDetailsForm.politicallyExposed" readonly>
            <el-radio label="yes" disabled>Yes</el-radio>
            <el-radio label="no" disabled>No</el-radio>
          </el-radio-group>
        </el-form-item>

        <button
          v-if="selectedDirector.status !== $STATUS.APPROVED"
          class="text-primary bg-white border border-primary hover:text-white hover:bg-primary rounded-lg mt-5 h-12 md:h-14 w-full hover:opacity-90"
          type="submit"
          :disabled="isLoading"
        >
          <spinner
            v-if="isLoading"
            size="small"
            :spacing="40"
            :line-fg-color="$primaryColor"
          />
          <span v-else>Remove</span>
        </button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
import {
  ALL_COUNTRIES,
  GENDER_TYPES,
  VALID_ID_TYPES,
  TITLE_TYPES,
  CITIZENSHIP
} from '@/utils/constants.js'
import breakpoints from '@/utils/breakpoints.js'
import { GetCountryFullName } from '@/utils/helpers.js'
import kyc from '@/mixins/kyc.js'

export default {
  name: 'ViewDirector',
  mixins: [kyc],
  data () {
    return {
      isLoading: false,
      genders: GENDER_TYPES,
      validIdTypes: VALID_ID_TYPES,
      allCountries: ALL_COUNTRIES,
      titles: TITLE_TYPES,
      options: [],
      kycStep: 5,
      directorIsUbo: this.selectedDirector.type === 'ubo',
      formData: new FormData(),
      directorsArray: [],
      kycDetailsForm: {
        title: this.selectedDirector.title || '',
        type: this.selectedDirector.type || '',
        name: this.selectedDirector.accountName || '',
        phoneNumber: this.selectedDirector.phoneNumber || '',
        gender: this.selectedDirector.gender || '',
        dateOfBirth: this.selectedDirector.dateOfBirth || '',
        country: this.selectedDirector.countryOfOperation
          ? GetCountryFullName(this.selectedDirector.countryOfOperation)
          : '',
        address: this.selectedDirector.businessAddress || '',
        bvn: this.selectedDirector.identityNumber || '',
        state: this.selectedDirector.state || '',
        postalCode: this.selectedDirector.postalCode || '',
        idNumber: this.selectedDirector.idNumber || '',
        shareholding: this.selectedDirector.shareholding || '',
        citizenship: this.selectedDirector.citizenship || '',
        idType: this.selectedDirector.idType || '',
        idCard: this.selectedDirector.documents?.length
          ? `${this.selectedDirector.documents[0].docType}${this.selectedDirector.documents[0].extension}`
          : '',
        proofOfAddress: this.selectedDirector.documents?.length
          ? `${this.selectedDirector.documents[1].docType}${this.selectedDirector.documents[1].extension}`
          : '',
        politicallyExposed: this.selectedDirector.isPoliticallyExposed || ''
      },
      initialType: this.selectedDirector.type,
      citizenshipOptions: [],
      isUltimateBeneficiaryOwner: false
    }
  },
  components: {
    CloseIcon: () => import('@/assets/v2/icons/CloseIcon.vue')
  },
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    selectedDirector: {
      type: Object,
      default: () => {}
    },
    type: {
      type: String,
      default: () => ''
    }
  },
  computed: {
    modalWidth () {
      return breakpoints.mdAndDown
        ? '90%'
        : breakpoints.lgAndDown
        ? '70%'
        : '38%'
    },
    bvnTitle () {
      const tenantName = process.env.VUE_APP_TENANT_NAME
      return tenantName === 'tma' ? 'BVN' : 'BVN / SSN'
    }
  },
  methods: {
    handleClose () {
      this.$emit('closeDialog')
    }
  }
}
</script>

<style scoped lang="scss">
button:disabled {
  opacity: 0.6;
  cursor: default;
}

>>> .el-radio__input.is-checked .el-radio__inner {
  border-color: var(--color-primary);
  background-color: var(--color-primary);
}

>>> .el-radio__input.is-checked + .el-radio__label {
  color: var(--color-primary);
}

>>> .is-disabled {
  opacity: 1;
}

>>> .el-radio__input.is-disabled.is-checked .el-radio__inner::after {
  background-color: white;
}
:deep(.el-checkbox__inner) {
  height: 1.3rem;
  width: 1.3rem;
}
:deep(.el-checkbox__inner::after) {
  height: 0.6rem;
  left: 0.4rem;
  border-width: 2px;
  top: 0.15rem;
}
:deep(.el-checkbox__label) {
  font-weight: 300;
  font-size: 0.95rem;
}
:deep(.el-checkbox__input.is-checked + .el-checkbox__label) {
  color: var(--color-primary);
}
</style>
